import { motion } from "framer-motion";
import { RevealText } from "@/components/shared/RevealText";
import { SectionLabel } from "@/components/shared/SectionLabel";

export const PageHero = ({ label, heading, description, image, imageAlt }) => (
  <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28 px-6 bg-navy overflow-hidden">
    <div className="absolute inset-0">
      <motion.img
        src={image}
        alt={imageAlt}
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-navy/70" />
    </div>
    <div className="max-w-5xl mx-auto relative">
      <SectionLabel light>{label}</SectionLabel>
      <RevealText
        as="h1"
        text={heading}
        className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold text-cream leading-[1.05] tracking-tight max-w-3xl"
      />
      {description && (
        <p className="mt-6 text-cream/75 text-base sm:text-lg max-w-2xl leading-relaxed">{description}</p>
      )}
    </div>
  </section>
);
